import { FC } from 'react';
import { useGetCurrentUser } from '@/custom-hooks';
import { useNavigate } from 'react-router';

type propsType = {
};

export const UserAssignmentsTelephonic: FC<propsType> = ({ }) => {
    const navigate = useNavigate();
    const user = useGetCurrentUser();

    return (
        <div className={'my-2'}>
            <h3>
                Territorios de Telefónica asignados:
            </h3>
            {!!user.phoneAssignments?.length ?
                user.phoneAssignments.map(territoryNumber =>
                    <button key={territoryNumber}
                        className={'btn btn-general-red d-inline-block text-center mt-3 mx-1 px-0'}
                        onClick={() => navigate(`/telefonica/${territoryNumber}`)}
                        style={{ fontWeight: 'bolder', width: '65px' }}
                    >
                        {territoryNumber}
                    </button>
                )
                :
                <h4>
                    Ninguno
                </h4>
            }
        </div>
    );
}
